import { Plan } from "./plan";
import { IPlanWithMetadata } from "./plan-or-metadata";

export class Subscription implements IPlanWithMetadata {
	id:string = "";
	status:string = "";
	startDate:Date = new Date();
	endDate:Date = new Date();
	nextPaymentDate:Date | null = null;
	price:number = 0;
	plan:Plan;
	rawMetadata:any;

	public constructor(data:any){
		this.id = data.id;
		this.status = data.status;
		this.startDate = new Date(data.startDate * 1000);
		this.endDate = new Date(data.endDate * 1000);
		this.price = data.price;
		this.plan = new Plan(data.plan);
		this.rawMetadata = data.rawMetadata;
		if (data.nextPaymentDate) {
			this.nextPaymentDate = new Date(data.nextPaymentDate * 1000);
		}
	}

	isCanceled():boolean{
		return this.status == "canceled";
	}
}
